import React from 'react'

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'contained' | 'outlined'
}

const baseStyles =
  'px-4 py-2 font-semibold cursor-pointer focus:outline-none transition-colors duration-150'

const variants = {
  contained:
    'bg-primary-pure text-white hover:bg-stone-800 border border-primary-pure disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed',
  outlined:
    'bg-transparent text-primary-pure border border-primary-pure hover:bg-stone-100 disabled:text-gray-400 disabled:border-gray-300 disabled:bg-transparent disabled:cursor-not-allowed',
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'contained',
  className = '',
  children,
  ...props
}) => {
  const variantClass = variants[variant]

  return (
    <button className={`${baseStyles} ${variantClass} ${className}`} {...props}>
      {children}
    </button>
  )
}